/** Evento document para cerrar un popup por id (coordinación entre instancias). */
export const POPUP_CLOSE_EVENT = 'close-popup' as const;

const openPopups = new Set<string>();

/** Cierra el resto de popups registrados vía evento global (un solo panel abierto a la vez). */
export function closeOtherPopups(excludeId: string): void {
  openPopups.forEach((id) => {
    if (id !== excludeId) {
      document.dispatchEvent(new CustomEvent(POPUP_CLOSE_EVENT, { detail: { id } }));
    }
  });
}

export function trackPopupOpen(id: string): void {
  openPopups.add(id);
}

export function trackPopupClose(id: string): void {
  openPopups.delete(id);
}
